module.exports = __webpack_public_path__ + "static/media/bannerHome1.327919d9.png";